export default "__VITE_ASSET__990fffab__"